// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-image {
  padding: 0 0.5rem 0 0.5rem;
  border: solid 1px #939CA3;
  background: #fff;
  max-width: 100%;
  max-height: 100%;
}

.fill-remaining-size {
  flex: 1 1 auto;
  height: inherit;
}

.center-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: inherit;
}

.myContainer {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  min-height: 100%;
  min-width: 100%;
}
.myContainer .mat-toolbar.mat-primary {
  top: 0;
  z-index: 2;
  position: sticky;
}

.mySidenavContainer {
  /* When the sidenav is not fixed, stretch the sidenav container to fill the available space. This
     causes \`<mat-sidenav-content>\` to act as our scrolling element for desktop layouts. */
  flex: 1;
}

/*
::ng-deep .mat-sidenav-container{
  height:100vh !important; /* or 100% *
}
*/`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/components/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;AACF;AACE;EACE,MAAA;EACA,UAAA;EACA,gBAAA;AACJ;;AAGA;EACE;0FAAA;EAEA,OAAA;AAAF;;AAGA;;;;CAAA","sourcesContent":[".toolbar-image {\r\n  padding: 0 0.5rem 0 0.5rem;\r\n  border: solid 1px #939CA3;\r\n  background: #fff;\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n}\r\n\r\n.fill-remaining-size {\r\n  flex: 1 1 auto;\r\n  height: inherit;\r\n}\r\n\r\n.center-image {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: inherit;\r\n}\r\n\r\n.myContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  min-height: 100%;\r\n  min-width: 100%;\r\n\r\n  .mat-toolbar.mat-primary {\r\n    top: 0;\r\n    z-index: 2;\r\n    position: sticky;\r\n  }\r\n}\r\n\r\n.mySidenavContainer {\r\n  /* When the sidenav is not fixed, stretch the sidenav container to fill the available space. This\r\n     causes `<mat-sidenav-content>` to act as our scrolling element for desktop layouts. */\r\n  flex: 1;\r\n}\r\n\r\n/*\r\n::ng-deep .mat-sidenav-container{\r\n  height:100vh !important; /* or 100% *\r\n}\r\n*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
